import { render } from "./PregAll.vue?vue&type=template&id=71a3a286&scoped=true"
import script from "./PregAll.vue?vue&type=script&lang=js"
export * from "./PregAll.vue?vue&type=script&lang=js"

import "./PregAll.vue?vue&type=style&index=0&id=71a3a286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a3a286"]])

export default __exports__